import { createContext } from 'react';

export type SettingsTab = 'general' | 'user-management' | 'surveys' | 'conversations';

export interface ISettingsMenuContext {
    isInSettings: boolean;
    setIsInSettings: (value: boolean) => void;
    activeTab: SettingsTab;
    setActiveTab: (tab: SettingsTab) => void;
    previousRoute: string | null;
    setPreviousRoute: (route: string | null) => void;
}

export const SettingsMenuContext = createContext<ISettingsMenuContext>({
    isInSettings: false,
    setIsInSettings: () => {},
    activeTab: 'general',
    setActiveTab: () => {},
    previousRoute: null,
    setPreviousRoute: () => {},
});
